import React from 'react';

import { withStyles } from '@mui/styles';

import ComponentWrapper from '../../common/ComponentWrapper';

import Cell from '../../common/Cell';
import Loader from '../../common/Loader';
import FlowPageStyles from './FlowPageStyles.js';
import CommonStyles from '../../common/CommonStyles';

import TrplCheckbox from '../../common/TrplControls/TrplCheckbox';

import { Table, TableHead, TableRow, TableBody, Button } from '@mui/material';

const styles = { ...CommonStyles, ...FlowPageStyles };

class FlowPage extends ComponentWrapper {
  state = {
    flows: [],
    loaded: false,
    btnsTypes: [],
    categories: [],
    stimulsTypes: [],
    editNewFlow: false,
    addNewStimul: false,
    editNewFlowName: '',
    deleteModalFlowIndex: null,
    isDeleteModalOpened: false,
    stimulView: {
      flow: {
        stimuls: [],
      },
      isOpened: false,
    },
    targetAudienceModal: {
      isOpened: false,
      flowIndex: 0,
      formula: {
        cons: [],
        ops: [],
      },
    },
  };

  componentDidMount() {
    document.title="Flows | Milkyweb";

    this.getFlows();
  }

  getFlows = () => {
    this.get({
      url: '/get_jel?type=["flow"]&meta_query=["setup_contacts_tbox", "stimuls_types", "btns_types"]',
      cb: (res) => {
        let flows = res.flow || [];

        const t_box = res._meta_query.setup_contacts_tbox;
        
        let categories = Object.keys(t_box.nodes).map(concept => res._meta_query.setup_contacts_tbox.nodes[concept]);

        if (!categories) categories = [];

        flows.forEach((flow) => {
          flow.expanded = false;
          if (!flow.channels) flow.channels = [];

          flow.stimuls.forEach((stimul) => {
            if (!stimul.btn_type) stimul.btn_type = '';
            if (!stimul.btn_title) stimul.btn_title = '';
            if (!stimul.btn_evoked_stimul) stimul.btn_evoked_stimul = '';
            if (!stimul.btn_fallback) stimul.btn_fallback = '';

            const category = categories.find(category => category.id === flow.category);

            flow.pidsValue = category ? this.getRsts(category) : [];
            if (!stimul.pids) stimul.pids = [];
          });
        });

        const pidsData = {};

        if (categories && categories.length) {
          categories.forEach(category => {
            if (category.box.r) {
              Object.keys(category.box.r).forEach(rstConcept => {
                const rsts = category.box.r[rstConcept];
                rsts.forEach(rst => pidsData[rst.id] = rst.title)
              });
            }
          });
        }

        const stimulsTypes = res._meta_query.stimuls_types || [];
        const btnsTypes = res._meta_query.btns_types || [];

        this.setState({
          flows,
          pidsData,
          btnsTypes,
          categories,
          stimulsTypes,
          loaded: true,
        });
      },
    });
  };

  onInputChange = (key, e) => {
    this.setState({ [key]: e.target.value });
  };

  getRsts = (category) => {
    const pidsValues = [];
    if (category && category.box.r && Object.keys(category.box.r).length) {
      Object.keys(category.box.r).forEach(rstConcept => {
        category.box.r[rstConcept].forEach(rst => pidsValues.push(rst))
      })
    };
    return pidsValues;
  };

  onEditNewFlow = () => {
    this.setState({ editNewFlow: true });
  };

  onAddNewFlow = (e) => {
    e.preventDefault();

    const { flows, editNewFlowName } = this.state;

    flows.push({
      title: editNewFlowName,
      category: 0,
      stimuls: [],
      isNew: true,
    });

    this.setState({ flows, editNewFlowName: '', editNewFlow: false });
  };

  onFlowFieldChange = (flowIndex, key, value) => {
    const { flows } = this.state;

    flows[flowIndex][key] = value;

    this.setState({ flows });
  };

  onAddNewStimulClick = (flowIndex) => {
    const { flows, categories } = this.state;

    const stimul = {
      pids: [],
      text: '',
      type: '',
      channels: [],
      func_receive: '',
      func_send: '',
      btn_fallback: '',
      btn_title: '',
      btn_evoked_stimul: '',
      btn_type: '',
    };

    const category = categories.find((category) => category.id === flows[flowIndex].category);

    flows[flowIndex].pidsValue = category ? this.getRsts(category) : [];

    flows[flowIndex].stimuls.push(stimul);

    this.setState({ flows });
  };

  onStimulBtnInputChange = (flowIndex, stimulIndex, key, value) => {
    const { flows } = this.state;

    flows[flowIndex].stimuls[stimulIndex][key] = value;

    this.setState({ flows });
  };

  onEditStimulBtnInputChange = (flowIndex, stimulIndex, btnIndex, key, value) => {
    const { flows } = this.state;

    flows[flowIndex].stimuls[stimulIndex].buttons[btnIndex][key] = value;

    this.setState({ flows });
  };

  onStimulFieldChange = (flowIndex, stimulIndex, key, value) => {
    const { flows } = this.state;

    flows[flowIndex].stimuls[stimulIndex][key] = value;

    this.setState({ flows });
  };

  onStimulBtnAdd = (flowIndex, stimulIndex) => {
    const { flows } = this.state;

    const stimul = flows[flowIndex].stimuls[stimulIndex];

    if (!flows[flowIndex].stimuls[stimulIndex].buttons) {
      flows[flowIndex].stimuls[stimulIndex].buttons = [];
    }

    flows[flowIndex].stimuls[stimulIndex].buttons.push({
      type: stimul.btn_type,
      title: stimul.btn_title,
      evoked_stimul: stimul.btn_evoked_stimul,
      fallback: stimul.btn_fallback,
    });

    flows[flowIndex].stimuls[stimulIndex].btn_title = '';
    flows[flowIndex].stimuls[stimulIndex].btn_type = '';
    flows[flowIndex].stimuls[stimulIndex].btn_evoked_stimul = '';
    flows[flowIndex].stimuls[stimulIndex].btn_fallback = '';

    this.setState({ flows });
  };

  onStimulBtnRemove = (flowIndex, stimulIndex, btnIndex) => {
    const { flows } = this.state;

    flows[flowIndex].stimuls[stimulIndex].buttons.splice(btnIndex, 1);

    this.setState({ flows });
  };

  onDeleteStimulClick = (flowIndex, stimulIndex) => {
    const { flows } = this.state;

    flows[flowIndex].stimuls.splice(stimulIndex, 1);

    this.setState({ flows });
  };

  onStimulModalPidsChange = (flowIndex, stimulIndex, value) => {
    const { flows } = this.state;

    flows[flowIndex].stimuls[stimulIndex].pids = value;

    this.setState({ flows });
  };

  onFlowChannelsChange = (flowIndex, value) => {
    const { flows } = this.state;

    if (value && value.includes('none')) {
      flows[flowIndex].channels = [];
    } else {
      flows[flowIndex].channels = value;
    }

    this.setState({ flows });
  };

  onStimulTypeChange = (flowIndex, stimulIndex, value) => {
    const { flows } = this.state;

    flows[flowIndex].stimuls[stimulIndex].type = value;

    this.setState({ flows });
  };

  onFlowSaveClick = (flowObj, index) => {
    const { flows, categories } = this.state;
    delete flowObj.isNew;
    delete flowObj.expanded;

    flowObj.stimuls.forEach((stimul) => {
      delete stimul.btn_title;
      delete stimul.btn_type;
      delete stimul.btn_evoked_stimul;
      delete stimul.btn_fallback;
    });

    if (flowObj.formula) {
      delete flowObj.formula.action;
      delete flowObj.formula.concept;
    }

    this.postWithData({
      url: '/rest/upd_jel?type=flow',
      data: flowObj,
      cb: (res) => {
        const { flow } = res;

        const category = categories.find((category) => category.id === flow.category);

        flow.pidsValue = flow.pidsValue = category ? this.getRsts(category) : [];

        flow.expanded = true;

        flows.splice(index, 1);
        flows.splice(index, 0, flow);

        this.setState({ flows });
      },
    });
  };

  onDeleteFlowClick = () => {
    const { flows, deleteModalFlowIndex } = this.state;

    this.get({ url: `/del_jel?id=${flows[deleteModalFlowIndex].id}` });

    flows.splice(deleteModalFlowIndex, 1);
    flows.forEach((flow) => (flow.expanded = false));

    this.setState({ flows });
    this.closeDeleteModal();
  };

  openDeleteModal = (flowIndex) => {
    this.setState({
      isDeleteModalOpened: true,
      deleteModalFlowIndex: flowIndex,
    });
  };

  closeDeleteModal = () => {
    this.setState({ isDeleteModalOpened: false, deleteModalFlowIndex: null });
  };

  onFlowCategoryChange = (flowIndex, value) => {
    const { flows, categories } = this.state;

    flows[flowIndex].category = value;

    const category = categories.find((category) => category.id === value);

    flows[flowIndex].flow.pidsValue = category ? this.getRsts(category) : [];

    this.setState({ flows });
  };

  toggleExpansionPanel = (flowIndex) => {
    const { flows } = this.state;

    flows[flowIndex].expanded = !flows[flowIndex].expanded;

    this.setState({ flows });
  };

  onStimulViewModalClose = (flow) => {
    const { stimulView } = this.state;

    stimulView.isOpened = false;
    stimulView.flow = {};

    this.setState({ stimulView });
  };

  onSaveStimulPositionsClick = (flow, index) => {
    this.onFlowSaveClick(flow, index);
  };

  onTargetAudienceSaveClick = (formula) => {
    const { flows } = this.state;
    const { flowIndex } = this.state.targetAudienceModal;

    if (!formula.cons.length && !formula.ops.length) {
      delete flows[flowIndex].formula;
    } else {
      flows[flowIndex].formula = formula;
    }

    this.setState({ flows });

    this.toggleTargetAudienceModal(false, flowIndex);
  };

  toggleTargetAudienceModal = (isOpened, flowIndex) => {
    const { flows, targetAudienceModal } = this.state;

    const plainFormula = {
      cons: [],
      ops: [],
    };

    const formula = flows[flowIndex].formula || plainFormula;

    if (isOpened) {
      targetAudienceModal.isOpened = true;
      targetAudienceModal.flowIndex = flowIndex;
      targetAudienceModal.formula = formula;
    } else {
      targetAudienceModal.isOpened = false;
      targetAudienceModal.flowIndex = 0;
      targetAudienceModal.formula = plainFormula;
    }

    this.setState({ targetAudienceModal });
  };

  render() {
    const { classes } = this.props;

    const { flows, categories, loaded } = this.state;

    return (
      <div className={classes.container}>
        {!loaded ? (
          <div className={`${classes.justifyCenter}`}>
            <Loader />
          </div>
        ) : (
          <Table
            style={{
              background: '#fff',
            }}
            className={classes.mb20}
          >
            <TableHead>
              <TableRow style={{ height: '40px' }}>
                <Cell style={{ width: '10px' }}>Id</Cell>
                <Cell>Title</Cell>
                <Cell>Audience</Cell>
                <Cell>Channels</Cell>
                <Cell>Permanent</Cell>
              </TableRow>
            </TableHead>

            <TableBody>
              {flows.map((flow, flowIndex) => {
                return (
                  <TableRow style={{ height: 'auto' }} key={flowIndex}>
                    <Cell>{flow.id}</Cell>

                    <Cell>
                      <a href={`/flow?id=${flow.id}`}>{flow.title}</a>
                    </Cell>
                    <Cell>
                      {flow.formula ? (
                        <div>
                          {flow.formula.cons.map((concept, conceptIndex) => {
                            const sub = categories.find((sub) => sub.id === concept);

                            if (conceptIndex === 0 && sub) {
                              return <span key={conceptIndex}>{sub.title} </span>;
                            }

                            return (
                              <span key={conceptIndex}>
                                {' '}
                                {flow.formula.ops[conceptIndex - 1]} {sub && sub.title ? sub.title : ''}
                              </span>
                            );
                          })}
                        </div>
                      ) : (
                        ''
                      )}
                    </Cell>
                    <Cell>{flow.channels.join(', ')}</Cell>
                    <Cell>
                      <TrplCheckbox checked={flow.permanent} className={classes.permanentCheckbox} />
                    </Cell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        )}

        <div className={classes.justifyEnd}>
          <Button size="small" variant="contained" color="primary">
            <a href="/flow" style={{ color: '#fff' }}>
              Add new flow
            </a>
          </Button>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(FlowPage);
